import { useMediaQuery, media } from '@utilitywarehouse/hearth-react';
import { color, space } from '@utilitywarehouse/hearth-tokens/js';
import { ReactNode } from 'react';

import { useTrackPsuPageLegalsClicked } from '~/tracking/trackingEvents';

import HearthAccordion from '../HearthAccordion';
import './FooterLegalAccordion.css';

interface FooterLegalAccordionProps {
  question: string;
  answer: ReactNode;
}

function FooterLegalAccordion({ question, answer }: FooterLegalAccordionProps) {
  const trackPsuPageLegalsClicked = useTrackPsuPageLegalsClicked();
  const isWide = useMediaQuery(media.wide);

  return (
    <HearthAccordion
      question={question}
      answer={answer}
      className="footer-legal-accordion"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
      triggerStyle={(isOpen) => ({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: color.grey[1000],
        fontWeight: 'bold',
        textDecoration: 'underline',
        border: 'none',
        paddingBottom: isOpen ? (isWide ? space[700] : space[200]) : undefined,
      })}
      onToggle={(isOpen) => {
        trackPsuPageLegalsClicked({ legals_opened: isOpen });
      }}
      scrollOnToggle
    />
  );
}

export default FooterLegalAccordion;
